<!-- src/App.vue -->
<template>
  <div v-if="showLayout" class="layout">
    <SidebarTemplate class="sidebar" />
    <MainTemplate class="main" />
  </div>
  <router-view v-else></router-view>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import SidebarTemplate from './components/SidebarTemplate.vue';
import MainTemplate from './components/MainTemplate.vue';

const route = useRoute();

const showLayout = computed(() => {
  return !route.meta.noLayout;
});
</script>


<style>
body {
  margin: 0;
  padding: 0;
}

.invoice-view-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--surface-section);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}
</style>

<style scoped>
.layout {
  --sidebar-width: 260px;
  display: flex;
  height: 100vh;
}

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--sidebar-width);
  height: 100vh;
  box-sizing: border-box;
  background-color: var(--surface-section);
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto; 
}

.main {
  margin-top: 4px;
  margin-left: calc(var(--sidebar-width) + 10px);
  margin-right: 10px;
  flex: 1;
  min-width: 0;
  width: calc(100% - var(--sidebar-width) - 20px);
  overflow-y: auto; 
}
</style>
